export const LOCATION_LABELS = {
  de: {
    headline: 'Wo Sie uns finden',
    mapLabel: 'Karte:',
    selectLocation: 'Standort wählen',
    phone: 'Telefon',
    email: 'E-Mail',
    website: 'Webseite',
    directions: 'Anfahrt',
    contactLabel: 'Ansprechpartner',
    routeLabel: 'Route anzeigen',
    emailLabel: 'E-Mail schreiben',
    faxLabel: 'Fax',
    phoneLabel: 'Telefon'
  },
  en: {
    headline: 'Where to find us',
    mapLabel: 'Map:',
    selectLocation: 'Select location',
    phone: 'Phone',
    email: 'Email',
    website: 'Website',
    directions: 'Directions',
    contactLabel: 'Contact Person',
    routeLabel: 'Show Route',
    emailLabel: 'Send Email',
    faxLabel: 'Fax',
    phoneLabel: 'Phone'
  }
};

export const getLocationLabels = (language = 'de') => {
  return LOCATION_LABELS[language] || LOCATION_LABELS.de;
};
